import React from 'react';

export default function BigElipsis(props: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill={props.fill || 'white'}
    >
      <circle cx="13" cy="25" r="3" />
      <circle cx="25" cy="25" r="3" />
      <circle cx="37" cy="25" r="3" />
    </svg>
  );
}
